import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InformationenComponent} from './informationen/informationen.component';
import {ProbenlisteComponent} from './probenliste/probenliste.component';
import {MatGridListModule} from "@angular/material/grid-list";
import {HttpClientModule} from "@angular/common/http";
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {APP_BASE_HREF, NgOptimizedImage} from '@angular/common';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from "@angular/material/input";
import {CommonModule} from "@angular/common";
import {HotTableModule} from '@handsontable/angular';
import {registerAllModules} from 'handsontable/registry';
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {CustomDateAdapter} from "./shared/custom-date-adapter";

// import * as Handsontable from "handsontable"

registerAllModules();

@NgModule({
  declarations: [
    AppComponent,
    InformationenComponent,
    ProbenlisteComponent,
  ],
  imports: [
    ReactiveFormsModule,
    HotTableModule,
    CommonModule,
    MatInputModule,
    MatSnackBarModule,
    BrowserModule,
    AppRoutingModule,
    MatTabsModule,
    BrowserAnimationsModule,
    MatGridListModule,
    HttpClientModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    MatButtonModule,
    NgOptimizedImage,
    MatDatepickerModule
  ],
  // providers: [{ provide: APP_BASE_HREF, useValue: '/dev' }],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: 'de'},

    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: []
    },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: {month: 'numeric', year: 'numeric', day: 'numeric'},
        },
        display: {
          dateInput: {month: '2-digit', year: 'numeric', day: '2-digit'},
          monthYearLabel: {year: 'numeric', month: '2-digit'},
          dateA11yLabel: {year: 'numeric', month: '2-digit', day: '2-digit'},
          monthYearA11yLabel: {year: 'numeric', month: '2-digit'},
        },
      }
    }
    // { provide: APP_BASE_HREF, useValue: '/dev'},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
